export enum AthenaTicketStatusEnums {
	Any = -1,
	Pending = 0,
    Processing = 1,
    Approved = 2,
    Rejected = 3,
    Cancelled = 4,
    ProcessingApprove = 5,
    ProcessingReject = 6,
    Approved1 = 7,
    PendingReview = 8,
    Approved2 = 9,
}

export const TicketStatusPrefix = 'Status_' as const;
type TicketStatusPrefix = typeof TicketStatusPrefix;
export type AthenaTicketStatusWithPrefix = `${TicketStatusPrefix}${AthenaTicketStatusEnums}`;

export interface AthenaTicketStatusSetting {
    label: string;
}

export const athenaTicketStatusSettings: Record<AthenaTicketStatusEnums, AthenaTicketStatusSetting> = {
	[AthenaTicketStatusEnums.Pending]: {
		label: 'lbl_status_0'
	},
	[AthenaTicketStatusEnums.Processing]: {
		label: 'lbl_status_1'
	},
	[AthenaTicketStatusEnums.Approved]: {
		label: 'lbl_status_2'
	},
	[AthenaTicketStatusEnums.Rejected]: {
		label: 'lbl_status_3'
	},
	[AthenaTicketStatusEnums.Cancelled]: {
		label: 'lbl_status_4'
	},
	[AthenaTicketStatusEnums.ProcessingApprove]: {
		label: 'lbl_status_1'
	},
	[AthenaTicketStatusEnums.ProcessingReject]: {
		label: 'lbl_status_1'
	},
	[AthenaTicketStatusEnums.Approved1]: {
		label: 'lbl_status_7'
	},
	[AthenaTicketStatusEnums.PendingReview]: {
		label: 'lbl_status_8'
	},
	[AthenaTicketStatusEnums.Approved2]: {
		label: 'lbl_status_9'
	},
	[AthenaTicketStatusEnums.Any]: {
		label: 'lbl_All'
	}
}
